import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Template pages from the Flexy starter are kept as reference building blocks,
 * but must not be reachable in a production build - not by direct URL, deep link
 * or push notification payload.
 *
 * Runs as canMatch so the lazy chunk is never fetched: the guard is evaluated
 * while the router is still matching the route, before the import kicks in.
 */
export const templateOnlyGuard: CanMatchFn = (): boolean | UrlTree =>
  environment.production ? inject(Router).createUrlTree(['/dashboard']) : true;
